import {RecordForm} from '../forms/RecordForm';


import {usePersona} from '../hooks/usePersona';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";


export const AddPage = () => {

    const {
        record,
        createRecord,
    } = usePersona();

    return (
        <FormPageLayout
            title='Add Persona'
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm record={record || {} as any} handleSubmit={createRecord}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
